module.exports = __webpack_public_path__ + "img/sddz1.0939c371.png";